import Cache from "node-cache";

const cache = new Cache({ stdTTL: 60 * 60 });

export function addToCache(key: string, data: any, ttl?: number): void {
  cache.set(key, data, ttl as number);
}

export function getFromCache(key: string): any {
  const data = cache.get(key);
  return data;
}

export function invalidateCache(key: string | string[]): boolean {
  try {
    cache.del(key);
  } catch (error) {
    return false;
  }

  return true;
}
